import { EventTypeId } from '@swf/sports/types/eventType';

export const isScoreboardSupportedEventType = (eventTypeId: EventTypeId) =>
  [EventTypeId.SOCCER, EventTypeId.TENNIS].includes(eventTypeId);
